import { Card, CardContent } from '@/components/ui/card'
import { Check } from 'lucide-react'
import { Link } from 'react-router-dom'

export function EmailLinkSentStep({
  email,
  onNext,
  mode = 'login',
}: {
  email: string | null
  onNext: () => void
  mode?: 'login' | 'signup'
}) {
  return (
    <Card className="rounded-lg border-base-border bg-base-card p-8 shadow-none">
      <CardContent>
        <div className="space-y-8">
          <div className="space-y-4">
            <div className="font-pp-supply-sans text-3xl font-normal">
              {mode === 'login' ? 'Sign in' : 'Sign up'}
            </div>
            <div className="space-y-1">
              <div className="font-medium text-base-foreground">
                <Check className="mr-2 inline-block text-2xl text-green-500" />
                {mode === 'login'
                  ? `If an account exists, a magic link was sent to ${email}`
                  : `If your email is not in use, a magic link was sent to ${email}`}
              </div>
              <div className="text-sm text-base-muted-foreground">
                Please check your inbox and spam folder and click on the link if you received it.
              </div>
            </div>
          </div>
          <div className="text-sm text-base-muted-foreground">
            {mode === 'login' ? (
              <>
                Don’t have an account?{' '}
                <Link to="/sign-up" className="underline">
                  Sign up
                </Link>
              </>
            ) : (
              <>
                Already have an account?{' '}
                <Link to="/sign-in" className="underline">
                  Sign in
                </Link>
              </>
            )}
          </div>
        </div>
      </CardContent>
    </Card>
  )
}
